export default "__VITE_ASSET__DwM591da__"